var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96875 5.625H6.375C6.76364 5.625 7.07812 5.31052 7.07812 4.92188C7.07812 4.53323 6.76364 4.21875 6.375 4.21875H4.96875C4.58011 4.21875 4.26562 4.53323 4.26562 4.92188C4.26562 5.31052 4.58011 5.625 4.96875 5.625Z",
    fill: "#FB6910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70183 3.43054C6.97647 3.70518 7.42146 3.70518 7.6961 3.43054C7.97074 3.1559 7.97074 2.71091 7.6961 2.43627L6.70183 1.442C6.42719 1.16736 5.98221 1.16736 5.70757 1.442C5.43293 1.71664 5.43293 2.16163 5.70757 2.43627L6.70183 3.43054Z",
    fill: "#FB6910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6731 3.43054L12.6674 2.43627C12.9421 2.16163 12.9421 1.71664 12.6674 1.442C12.3928 1.16736 11.9478 1.16736 11.6731 1.442L10.6789 2.43627C10.4042 2.71091 10.4042 3.1559 10.6789 3.43054C10.9535 3.70518 11.3985 3.70518 11.6731 3.43054Z",
    fill: "#FB6910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70183 6.41326L5.70757 7.40752C5.43293 7.68216 5.43293 8.12715 5.70757 8.40179C5.98221 8.67643 6.42719 8.67643 6.70183 8.40179L7.6961 7.40752C7.97074 7.13288 7.97074 6.6879 7.6961 6.41326C7.42146 6.13862 6.97647 6.13862 6.70183 6.41326Z",
    fill: "#FB6910"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 2.8125C9.57614 2.8125 9.89062 2.49802 9.89062 2.10938V0.703125C9.89062 0.314484 9.57614 0 9.1875 0C8.79886 0 8.48438 0.314484 8.48438 0.703125V2.10938C8.48438 2.49802 8.79886 2.8125 9.1875 2.8125Z",
    fill: "#FB6910"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5938 24H17.625C18.7882 24 19.7344 23.0538 19.7344 21.8906V6.32812C19.7344 5.16497 18.7882 4.21875 17.625 4.21875H10.5938C9.43059 4.21875 8.48438 5.16497 8.48438 6.32812V21.8906C8.48438 23.0538 9.43059 24 10.5938 24ZM12 7.03125C12.3883 7.03125 12.7031 7.34606 12.7031 7.73438C12.7031 8.12269 12.3883 8.4375 12 8.4375C11.6117 8.4375 11.2969 8.12269 11.2969 7.73438C11.2969 7.34606 11.6117 7.03125 12 7.03125ZM12 9.84375C12.3883 9.84375 12.7031 10.1586 12.7031 10.5469C12.7031 10.9352 12.3883 11.25 12 11.25C11.6117 11.25 11.2969 10.9352 11.2969 10.5469C11.2969 10.1586 11.6117 9.84375 12 9.84375Z",
    fill: "#FB6910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.ed9198e3992d643ab7f8207eb02db84e.svg";
export { ForwardRef as ReactComponent };